import request from '@/utils/request'

/**
 * 查询出入库订单
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/queryInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询出入库订单商品
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryInoutOrderProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder.queryInoutOrderProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存出库订单
 * @param {Object} data 订单数据
 * @returns {Promise} 返回Promise对象
 */
export function saveOrderOut(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/saveOrderOut',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新出入库订单
 * @param {Object} data 订单数据
 * @returns {Promise} 返回Promise对象
 */
export function updateInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/updateInoutOrder',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新出入库订单商品
 * @param {Object} data 商品数据
 * @returns {Promise} 返回Promise对象
 */
export function updateInoutOrderProduct(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrderProduct/updateInoutOrderProduct',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}